import config from '@/config'
import log from '@/logger'
import { ls } from '@/services/storage'

let globalPlayerLoginWindow
let globalPlayerSettingsWindow

const openPopupWindow = (url, title) => {
  const width = 500
  const height = 750
  const left = screen.width / 2 - width / 2
  const top = screen.height / 2 - height / 2
  return window.open(url, title, `popup=yes,width=${width},height=${height},left=${left},top=${top}`)
}

export default [
  {
    path: '/login',
    name: 'login',
    beforeEnter (to, from, next) {
      if (to.query.code) {
        ls.set('code-v2', to.query.code)
        window.opener.location.reload()
        window.close()
      } else {
        // const redirectUri = 'https://example.org'
        const redirectUri = `${window.location.origin}/login`
        const scope = 'openid+uid+profile+email+address+phones'
        const href = `${config.GLOBAL_LOGIN_URL}/authorize?client_id=${config.GLOBAL_LOGIN_CLIENT_ID}&redirect_uri=${redirectUri}&response_type=code&scope=${scope}`
        if (globalPlayerLoginWindow) {
          log.info('global-player-login-closing-previous-window')
          globalPlayerLoginWindow.close()
        }
        log.info('global-player-login-open', href)
        globalPlayerLoginWindow = openPopupWindow(href, 'globalPlayerLoginWindow')
        if (!globalPlayerLoginWindow) {
          log.error('global-player-login-open-failed')
        }
      }
    }
  },
  {
    path: '/global-player/settings',
    name: 'global-player-settings',
    beforeEnter (to, from, next) {
      const href = 'https://www.globalplayer.com/settings/edit-profile/'
      if (globalPlayerSettingsWindow) {
        log.info('global-player-settings-closing-previous-window')
        globalPlayerSettingsWindow.close()
      }
      log.info('global-player-settings-open', href)
      globalPlayerSettingsWindow = openPopupWindow(href, 'globalPlayerSettingsWindow')
      if (!globalPlayerSettingsWindow) {
        log.error('global-player-settings-open-failed')
      }
    }
  }
]
